import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { EXAM_BTN_CLICK_TYPE } from "types/enums/examination";

type State = {
  actionType: EXAM_BTN_CLICK_TYPE,
  dataPassing: any
};

const initialState: State = {
  actionType: EXAM_BTN_CLICK_TYPE.NONE,
  dataPassing: null
};

export const eBCSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setEBCType: (state = initialState, action: PayloadAction<any>) => {
      return {...state, actionType: action.payload}
    },
    setEBCDataPassing: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataPassing: action.payload}
    },
    setEBC: (state = initialState, action: PayloadAction<any>) => {
      return {actionType: action.payload.actionType, dataPassing: action.payload.dataPassing}
    }
  },
});

export const {setEBC, setEBCDataPassing, setEBCType} = eBCSlice.actions;

export default eBCSlice.reducer;
